export default {
  namespaced: true,
  state: {
    // Track generation status per bounded context
    // { boundedContextId: { name, workflowId, status, startedAt } }
    generatingBoundedContexts: {}
  },
  mutations: {
    setGenerating (state, { boundedContextId, name, workflowId }) {
      state.generatingBoundedContexts[boundedContextId] = {
        name,
        workflowId,
        status: 'generating',
        startedAt: Date.now()
      }
    },
    setCompleted (state, { boundedContextId }) {
      if (state.generatingBoundedContexts[boundedContextId]) {
        delete state.generatingBoundedContexts[boundedContextId]
      }
    },
    setFailed (state, { boundedContextId, error }) {
      if (state.generatingBoundedContexts[boundedContextId]) {
        state.generatingBoundedContexts[boundedContextId].status = 'failed'
        state.generatingBoundedContexts[boundedContextId].error = error
      }
    },
    clearAll (state) {
      state.generatingBoundedContexts = {}
    }
  },
  getters: {
    isGenerating: (state) => (boundedContextId) => {
      return !!state.generatingBoundedContexts[boundedContextId]
    },
    activeGenerations: (state) => {
      return Object.entries(state.generatingBoundedContexts).map(([id, data]) => ({
        boundedContextId: id,
        ...data
      }))
    },
    activeGenerationsCount: (state, getters) => {
      return getters.activeGenerations.length
    }
  }
}
